import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BSPagination from "../../Components/pagination";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const UserPermissionsList = ({ listData = [], getData }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 5,
    totalPages: 1,
  });

  const handleEditUserPermissions = (id) => {
    if (id) {
      localStorage.setItem("userId", id);
      navigate(`/userPermissions/edit`);
    }
  };

  const paginatedData = listData.slice(
    (pagination.currentPage - 1) * pagination.pageSize,
    pagination.currentPage * pagination.pageSize
  );

  // Re-fetch or any side-effects when page changes
  useEffect(() => {
    // If you need to reload from server on page change, call getData here
    // getData(currentPage);
  }, [currentPage]);

  // Initialize or update DataTable on paginatedData change
  useEffect(() => {
    const rows = paginatedData.map((item, idx) => [
      (currentPage - 1) * pageSize + idx + 1,
      `${item.first_name || ""} ${item.last_name || ""}`,
      item.role?.name || "",
      item.permissions_count || 0,
      item.role_permissions_count || 0,
      item.status === 1 ? "Active" : "Inactive",
      "", // placeholder for actions
    ]);

    const config = {
      data: rows,
      columns: [
        { title: "ID", className: "text-start" },
        { title: "Name" },
        { title: "Role" },
        { title: "User Permissions" },
        { title: "Role Permissions" },
        { title: "Status" },
        { title: "Actions", orderable: false, searchable: false },
      ],
      destroy: true,
      paging: false,
      searching: false,
      info: false,
      responsive: true,
      createdRow: function (row, data, dataIndex) {
        // Status color
        $("td", row)
          .eq(5)
          .addClass(data[5] === "Active" ? "text-success" : "text-danger")

        // Actions button
        const id = listData[(currentPage - 1) * pageSize + dataIndex].id;
        const btn = $(
          `<button class="btn btn-sm btn-outline-primary"><i class="fa fa-edit" title="grant/revoke permissions"></i></button>`
        ).on("click", () => handleEditUserPermissions(id));
        $("td", row).eq(6).empty().append(btn);
      },
    };

    const $tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      $tbl.DataTable(config);
    }

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $tbl.DataTable().destroy();
      }
    };
  }, [paginatedData, listData, currentPage]);

  return (
    <div
      className="container py-4 text-light bg-dark rounded mb-4"
      style={{ minHeight: "max-content" }}
    >
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-dark table-striped align-middle"
        />
        <div className="d-flex justify-content-end mt-2">
          <BSPagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={(page) =>
              setPagination((p) => ({ ...p, currentPage: page }))
            }
            siblingCount={2}
            showFirstLast
          />
        </div>
      </div>
    </div>
  );
};

export default UserPermissionsList;
